// extracted by mini-css-extract-plugin
export default {"otpForm":"style_otpForm__ETx+F"};